<!-- eslint-disable -->
<template>

  <div id="container" class="hfeed wpbf-page">
  <loader
      object="var( --e-global-color-primary)"
      v-if="isLoading"
      color1="#ffffff"
      color2="#999793"
      size="5"
      speed="2"
      bg="#343a40"
      objectbg="#999793"
      opacity="80"
      name="spinning"
    ></loader>
    <!--START OF HEADER NAV BAR-->
	
    <!--END OF HEADER NAV BAR-->
    <div
      data-elementor-type="wp-page"
      data-elementor-id="1983"
      class="elementor elementor-1983"
      data-elementor-settings="[]"
    >
      <div class="elementor-section-wrap">
        <!--START of BACKGROUND SLIDER-->

        <!--END of BACKGROUND SLIDER-->
        <section
          class="has_eae_slider elementor-section elementor-top-section elementor-element elementor-section-height-min-height elementor-section-content-middle elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
          data-particle_enable="false"
          data-particle-mobile-disabled="false"
          data-id="17739ff"
          data-element_type="section"
          data-settings='{"stretch_section":"section-stretched"}'
        >
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-no">
            <div
              class="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7ac1db2"
              data-id="7ac1db2"
              data-element_type="column"
            >
              <div class="elementor-widget-wrap elementor-element-populated">
                <section
                  class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-095ef7d elementor-section-full_width elementor-section-content-middle elementor-section-height-default elementor-section-height-default"
                  data-particle_enable="false"
                  data-particle-mobile-disabled="false"
                  data-id="095ef7d"
                  data-element_type="section"
                >
                  <div class="elementor-container elementor-column-gap-no">
                    <div
                      class="has_eae_slider elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-d4412b2"
                      data-id="d4412b2"
                      data-element_type="column"
                      data-settings='{"background_background":"classic"}'
                    >
                      <div
                        class="elementor-widget-wrap elementor-element-populated"
                      >
                        <!--START of CHECKOUT ITEM TABLE-->
                        <div
                          class="elementor-element elementor-element-ff28744 elementor-widget elementor-widget-tp-table"
                          data-id="ff28744"
                          data-element_type="widget"
                          data-widget_type="tp-table.default"
                        >
                          <div class="elementor-widget-container">
                            <div itemscope class="plus-table-wrapper" style="max-height: 350px; overflow-y: scroll;">
                              <table
                                id="plus-table-id-ff28744"
                                class="plus-table plus-text-break plus-column-rules checkout-table"
                                data-sort-table="no"
                                data-show-entry="no"
                                data-searchable="no"
                              >
                                <thead>
                                  <tr class="plus-table-row">
                                    <th
                                      id="tooltip61ca7f619268f"
                                      data-sort="0"
                                      class="sort-this elementor-repeater-item-ade8803 plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span
                                            class="plus-table__text-inner"
                                          ></span>
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      id="tooltip61ca7f61926a1"
                                      data-sort="1"
                                      class="sort-this elementor-repeater-item-0f9cc67 plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span
                                            class="plus-table__text-inner"
                                          ></span>
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      id="tooltip61ca7f61926ae"
                                      data-sort="2"
                                      class="sort-this elementor-repeater-item-9e20a5c plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span class="plus-table__text-inner"
                                            >{{lang.checkOut.items}}</span
                                          >
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      id="tooltip61ca7f61926ba"
                                      data-sort="3"
                                      class="sort-this elementor-repeater-item-8c532cc plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span class="plus-table__text-inner">
                                          </span>
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      id="tooltip61ca7f61926c5"
                                      data-sort="4"
                                      class="sort-this elementor-repeater-item-a657855 plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span class="plus-table__text-inner"
                                            >{{lang.checkOut.qty}}</span
                                          >
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      id="tooltip61ca7f61926d1"
                                      data-sort="5"
                                      class="sort-this elementor-repeater-item-46795f3 plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span class="plus-table__text-inner"
                                            >{{lang.checkOut.subTotal}}</span
                                          >
                                        </span>
                                      </span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <!-- ROWS -->

                                  <tr
                                    v-for="cartItem in cart.items"
                                    :key="cartItem.id"
                                    data-entry="1"
                                    class="plus-table-row"
                                  >
                                    <td
                                      id="tooltip61ca7f61926f3"
                                      class="plus-table-col elementor-repeater-item-909e904"
                                    >
                                      <a @click="removeCart(cartItem.item_id)" class="tb-col-link">
                                        <span class="plus-table__text">
                                          <span class="plus-align-icon--left">
                                            <i class="fa fa-remove"></i>
                                          </span>
                                        </span>
                                      </a>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192dbf"
                                      class="plus-table-col elementor-repeater-item-6323f50"
                                    >
                                      <span class="plus-table__text">
                                       
										                    <img :src="baseUrl + cartItem.image" class="plus-col-img--left" title="91_trcybzs433rmm_t800x800" alt="91_trcybzs433rmm_t800x800">
                                      </span>
                                      
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192df0"
                                      class="plus-table-col elementor-repeater-item-4a20cff"
                                      data-title="Item"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ cartItem.name }}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e03"
                                      class="plus-table-col elementor-repeater-item-23993e6"
                                      data-title="Price"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner">
                                        </span>
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e16"
                                      class="plus-table-col elementor-repeater-item-21b7c99"
                                      data-title="Qty"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ cartItem.quantity }}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e34"
                                      class="plus-table-col elementor-repeater-item-9a4799b"
                                      data-title="Sub Total"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ cartItem.purchased_price * cartItem.quantity  }} {{currency}}</span
                                        >
                                      </span>
                                    </td>
                                  </tr>
                                  <tr data-entry="2" class="plus-table-row">
                                    <td
                                      id="tooltip61ca7f6192e5b"
                                      class="plus-table-col elementor-repeater-item-18e4b68"
                                      colspan="5"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{lang.checkOut.subTotal}}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e69"
                                      class="plus-table-col elementor-repeater-item-1eb938f"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          > {{ cart.subtotal }} {{currency}}</span
                                        >
                                      </span>
                                    </td>
                                  </tr>
								  <tr data-entry="2" class="plus-table-row">
                                    <td
                                      id="tooltip61ca7f6192e5b"
                                      class="plus-table-col elementor-repeater-item-18e4b68"
                                      colspan="5"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{lang.checkOut.tax}}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e69"
                                      class="plus-table-col elementor-repeater-item-1eb938f"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ cart.tax   }}%</span
                                        >
                                      </span>
                                    </td>
                                  </tr>
								  <tr data-entry="2" class="plus-table-row">
                                    <td
                                      id="tooltip61ca7f6192e5b"
                                      class="plus-table-col elementor-repeater-item-18e4b68"
                                      colspan="5"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{lang.checkOut.grandTotal}}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e69"
                                      class="plus-table-col elementor-repeater-item-1eb938f"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ cart.total_price }} {{currency}}</span
                                        >
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <!--END of CHECKOUT ITEM TABLE-->

                        <!-- ALLERGY / DIETARY NOTES SECTION -->
                        <div class="allergy-checkout-card">
                          <div class="allergy-checkout-header">
                            <i class="fa fa-exclamation-circle" style="color: #d7b578; margin-right: 8px; margin-left: 8px;"></i>
                            <span>{{ allergyTexts.title }}</span>
                          </div>
                          <p class="allergy-checkout-subtitle">{{ allergyTexts.subtitle }}</p>
                          <div class="allergy-checkout-chips">
                            <button
                              type="button"
                              class="allergy-chip"
                              :class="{ active: selectedAllergies.length === 0 && !customAllergyNote.trim() }"
                              @click="clearAllergies()"
                            >
                              <i class="fa fa-check-circle" v-if="selectedAllergies.length === 0 && !customAllergyNote.trim()"></i>
                              {{ allergyTexts.none }}
                            </button>
                            <button
                              type="button"
                              v-for="item in allergyOptions"
                              :key="item.key"
                              class="allergy-chip"
                              :class="{ 'active-allergy': isAllergySelected(item.label) }"
                              @click="toggleAllergy(item.label)"
                            >
                              <i class="fa" :class="isAllergySelected(item.label) ? 'fa-check-square-o' : 'fa-square-o'"></i>
                              {{ item.label }}
                            </button>
                          </div>
                          <input
                            type="text"
                            v-model="customAllergyNote"
                            class="allergy-custom-input"
                            :placeholder="allergyTexts.placeholder"
                          />
                        </div>
                        <!-- END ALLERGY / DIETARY NOTES SECTION -->

                        <div
                          class="elementor-element elementor-element-9586c17 elementor-widget-elementskit-dual-button-end elementor-widget-elementskit-dual-button-mobile-end elementor-widget elementor-widget-elementskit-dual-button"
                          data-id="9586c17"
                          data-element_type="widget"
                          data-widget_type="elementskit-dual-button.default"
                        >
                          <div class="elementor-widget-container">
                            <div class="ekit-wid-con">
                              <div class="ekit-element-align-wrapper">
                                <div class="ekit_double_button d-flex">
                                  <button
                                    class="ekit-double-btn ekit-double-btn-one"
                                    @click="checkOut()"
                                    >{{lang.checkOut.placeYourOrder}}<i
                                      aria-hidden="true"
                                      class="icon icon-shopping-cart-1"
                                    ></i>
                                  </button>
                                  <router-link
                                    class="ekit-double-btn ekit-double-btn-two"
                                    :to="{ name: 'Menu', params: {menuId: restaurant_id} }"
                                  >
                                    <i
                                      aria-hidden="true"
                                      class="fas fa-undo"
                                    ></i
                                    >{{lang.checkOut.backToBooking}}</router-link
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
const ALLERGY_DICTIONARY = {
  en: {
    title: "Food Allergies & Dietary Notes",
    subtitle: "Do you or your companions have any food allergies? Select below or type your notes:",
    none: "No Allergies",
    placeholder: "Other allergies or dietary notes (optional)...",
    options: [
      { key: "nuts", label: "Nuts / Peanuts" },
      { key: "dairy", label: "Dairy / Lactose" },
      { key: "gluten", label: "Gluten / Wheat" },
      { key: "seafood", label: "Seafood / Shellfish" },
      { key: "eggs", label: "Eggs" },
      { key: "soy", label: "Soy" },
      { key: "sesame", label: "Sesame" }
    ]
  },
  fr: {
    title: "Allergies alimentaires et notes diététiques",
    subtitle: "Avez-vous des allergies alimentaires ? Sélectionnez ci-dessous ou saisissez vos notes :",
    none: "Aucune allergie",
    placeholder: "Autres allergies ou remarques alimentaires (facultatif)...",
    options: [
      { key: "nuts", label: "Fruits à coque / Arachides" },
      { key: "dairy", label: "Produits laitiers / Lactose" },
      { key: "gluten", label: "Gluten / Blé" },
      { key: "seafood", label: "Fruits de mer / Crustacés" },
      { key: "eggs", label: "Œufs" },
      { key: "soy", label: "Soja" },
      { key: "sesame", label: "Sésame" }
    ]
  },
  it: {
    title: "Allergie alimentari e note dietetiche",
    subtitle: "Avete allergie alimentari? Selezionate qui sotto o inserite le vostre note:",
    none: "Nessuna allergia",
    placeholder: "Altre allergie o note alimentari (facoltativo)...",
    options: [
      { key: "nuts", label: "Frutta a guscio / Arachidi" },
      { key: "dairy", label: "Latticini / Lattosio" },
      { key: "gluten", label: "Glutine / Grano" },
      { key: "seafood", label: "Frutti di mare / Crostacei" },
      { key: "eggs", label: "Uova" },
      { key: "soy", label: "Soia" },
      { key: "sesame", label: "Sesamo" }
    ]
  },
  de: {
    title: "Lebensmittelallergien & Ernährungshinweise",
    subtitle: "Haben Sie Lebensmittelallergien? Bitte unten auswählen oder eingeben:",
    none: "Keine Allergien",
    placeholder: "Weitere Allergien oder Hinweise (optional)...",
    options: [
      { key: "nuts", label: "Nüsse / Erdnüsse" },
      { key: "dairy", label: "Milchprodukte / Laktose" },
      { key: "gluten", label: "Gluten / Weizen" },
      { key: "seafood", label: "Meeresfrüchte / Schalentiere" },
      { key: "eggs", label: "Eier" },
      { key: "soy", label: "Soja" },
      { key: "sesame", label: "Sesam" }
    ]
  },
  ru: {
    title: "Пищевая аллергия и диетические примечания",
    subtitle: "Есть ли у вас пищевая аллергия? Выберите ниже или введите примечание:",
    none: "Нет аллергии",
    placeholder: "Другие виды аллергии или примечания (необязательно)...",
    options: [
      { key: "nuts", label: "Орехи / Арахис" },
      { key: "dairy", label: "Молочные продукты / Лактоза" },
      { key: "gluten", label: "Глютен / Пшеница" },
      { key: "seafood", label: "Морепродукты / Моллюски" },
      { key: "eggs", label: "Яйца" },
      { key: "soy", label: "Соя" },
      { key: "sesame", label: "Кунжут" }
    ]
  },
  ar: {
    title: "حساسية الطعام والملاحظات الغذائية",
    subtitle: "هل تعاني أنت أو مرافقوك من أي حساسية طعام؟ اختر من القائمة أو اكتب ملاحظاتك:",
    none: "لا توجد حساسية",
    placeholder: "أنواع حساسية أخرى أو ملاحظات غذائية (اختياري)...",
    options: [
      { key: "nuts", label: "مكسرات / فول سوداني" },
      { key: "dairy", label: "ألبان / لاكتوز" },
      { key: "gluten", label: "غلوتين / قمح" },
      { key: "seafood", label: "مأكولات بحرية / محار" },
      { key: "eggs", label: "بيض" },
      { key: "soy", label: "صويا" },
      { key: "sesame", label: "سمسم" }
    ]
  }
};

export default {
  name: "Checkout",
  data() {
    return {
       hotelId: 1,
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      restaurant_id: this.$route.params.restId.split("_")[0],
      booking_id: this.$route.params.restId.split("_")[1],
      orderId: this.$route.params.orderId,
	  guestData:[],
      cart: {
        
        items: [],
        tax: 0,
        total_price: 0,
        subtotal:0,

      },
	  isLoading: false,
        lang:"",
		currency:"",
      selectedAllergies: [],
      customAllergyNote: ""
    }
  },
  computed: {
    currentLocale() {
      return localStorage.getItem("localization") || (this.$i18n && this.$i18n.locale) || "en";
    },
    allergyTexts() {
      return ALLERGY_DICTIONARY[this.currentLocale] || ALLERGY_DICTIONARY.en;
    },
    allergyOptions() {
      return this.allergyTexts.options;
    },
    combinedAllergies() {
      const parts = [];
      if (this.selectedAllergies.length > 0) {
        parts.push(this.selectedAllergies.join(", "));
      }
      if (this.customAllergyNote && this.customAllergyNote.trim()) {
        parts.push(this.customAllergyNote.trim());
      }
      return parts.join(" - ");
    }
  },
  created() {
    this.setLang();
    this.initSavedAllergies();
    this.getCartData();
	this.getGuestInfo();
	this.currency=localStorage.getItem("currency");
  },
  methods: {
    initSavedAllergies() {
      const saved = localStorage.getItem("currentBookingAllergies");
      if (saved && saved.trim()) {
        this.customAllergyNote = saved.trim();
      }
    },
    isAllergySelected(label) {
      return this.selectedAllergies.indexOf(label) !== -1;
    },
    toggleAllergy(label) {
      const idx = this.selectedAllergies.indexOf(label);
      if (idx === -1) {
        this.selectedAllergies.push(label);
      } else {
        this.selectedAllergies.splice(idx, 1);
      }
    },
    clearAllergies() {
      this.selectedAllergies = [];
      this.customAllergyNote = "";
      localStorage.removeItem("currentBookingAllergies");
    },
    getCartData(){
      this.axios
      .get(
        process.env.VUE_APP_API_BASE_URL +
        "api/order-data-not-checkout?api_key="+
          process.env.VUE_APP_API_KEY +
          "&lang=" +
          localStorage.getItem('localization') +
          "&api_token=" +
                 localStorage.getItem("token") +
          "&restaurant_id="+this.restaurant_id+
            "&hotel_id=1"
      )
      .then((res) => {
       console.log(res)
      if(res.data.data){
       console.log('y')
        this.cart = res.data.data
        this.cart.items.forEach((d, index) => {
          this.itemsInCart.push(d.id)
        });

      }else{
       console.log('n')

      }
       console.log(res.data.data)

      })
      .catch((error) => console.log(error));
    },
    setLang() {
      this.axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "api/frontend-keywords?api_key=" +
            process.env.VUE_APP_API_KEY +
            "&lang=" +
            localStorage.getItem("localization")
        )
        .then(
          (res) => {
            console.log(res)
            this.lang = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
   removeCart(item) {
      this.isLoading = true;

      var formData = {
        
        api_key: process.env.VUE_APP_API_KEY,
        lang: localStorage.getItem('localization'),
        order_id: this.cart.id,
        api_token:localStorage.getItem("token") ,
        item_id: item,
        order_id: this.cart.id
      };
        // api_token:localStorage.getItem("token") ,

      this.axios
        .post(process.env.VUE_APP_API_BASE_URL + "api/remove-order-item", formData)
        .then((res) => {
          this.isLoading = false;
          this.getCartData();
          console.log(res.data)
          // this.$notify({
          //   group: "foo",
          //   title: "Success",
          //   text: "item removed successfully ",
          //   type: "success",
          // });
        })
        .catch((error) => {
          this.isLoading = false;

          this.errors = error;
          this.$notify({
            group: "foo",
            title: "Invalid Login",
            text: "Something error in remove from cart please check your inputs and try again ",
            type: "error",
          });
          console.log(error);
        });

      // console.log(this.cart.cartItems)
    },getGuestInfo(){
		this.axios
      .get(
        process.env.VUE_APP_API_BASE_URL +
          "api/user-profile?api_key=" +
          process.env.VUE_APP_API_KEY +
          "&lang=" +
          process.env.VUE_APP_LANG +
          "&api_token=" +
                 localStorage.getItem("token") +
          "&hotel_id=1&restaurant_id=1"
      )
      .then((res) => {
		  console.log(" ----------- Guest Info ---------");
		  console.log(res);
        this.guestData.guestName = res.data.data.first_name + ' ' + res.data.data.last_name
        this.guestData.guestRoom = res.data.data.more_data.room_number
        this.guestData.guestReservation = res.data.data.more_data.reservation
        this.guestData.guestArrivalData = res.data.data.more_data.checkin_date
        this.guestData.guestDepartureDate = res.data.data.more_data.checkout_date
		this.guestData.companions = res.data.data.more_data.companions
        this.isLoading = false;


 
      })
      .catch((error) => console.log(error));
	},
    checkOut(){
      this.isLoading = true;
      const allergiesPayload = this.combinedAllergies;
      if (allergiesPayload) {
        localStorage.setItem("currentBookingAllergies", allergiesPayload);
      } else {
        localStorage.removeItem("currentBookingAllergies");
      }

        var formData = {
          api_key: process.env.VUE_APP_API_KEY,
          lang: localStorage.getItem('localization'),
          api_token: localStorage.getItem("token"),
          order_id: this.orderId,
          booking_id: localStorage.getItem('currentBookingID'),
		  number_of_companions:this.guestData.companions,
          allergies: allergiesPayload
        };

        this.axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "api/order-checkout",
            formData
          )
          .then((res) => {
            this.isLoading = false;
            console.log(res.data);
            // this.$notify({
            //   group: "foo",
            //   title: res.data.message,
            //   text: res.data.message,
            //   type: "success",
            // });
          this.$router.push({ name: "QrPrint" , id:this.$route.params.id , orderId:this.o});

          })
          .catch((error) => {
            this.isLoading = false;

            this.errors = error;
            this.$notify({
              group: "foo",
              title: "Invalid",
              text: "Something error in add to cart please check your inputs and try again ",
              type: "error",
            });
            console.log(error);
          });
    }
  },
   
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.allergy-checkout-card {
  background: rgba(20, 20, 20, 0.85);
  border: 1px solid rgba(215, 181, 120, 0.55);
  border-radius: 10px;
  padding: 14px 18px;
  margin: 14px 0;
  color: #ffffff;
}
.allergy-checkout-header {
  font-size: 1.05rem;
  font-weight: 700;
  color: #d7b578;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}
.allergy-checkout-subtitle {
  font-size: 0.88rem;
  color: #dcdcdc;
  margin-bottom: 10px;
}
.allergy-checkout-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 10px;
}
.allergy-chip {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #ffffff;
  border-radius: 20px;
  padding: 6px 13px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.allergy-chip.active {
  background: #28a745;
  border-color: #28a745;
  color: #ffffff;
  font-weight: 600;
}
.allergy-chip.active-allergy {
  background: #dc3545;
  border-color: #ff6b81;
  color: #ffffff;
  font-weight: 600;
}
.allergy-custom-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  color: #222222;
  border: 1px solid #d7b578;
  border-radius: 7px;
  padding: 8px 12px;
  font-size: 0.9rem;
}
</style>
<style>
#plus-table-id-ff28744 th,
#plus-table-id-ff28744 th .plus-table__text {
  margin: 0 auto;
  text-align: left;
  margin-left: 0;
}
@media(max-width:767px) {
  .checkout-table td .plus-table__text-inner{
      font-size: 0.9em !important;
      line-height: 1.5em !important;
  }
  .checkout-table th.plus-table-col {
        font-size: 0.7em !important;
  }
  /* .ekit-wid-con .ekit_double_button {
        display: flex !important;
      
    } */
    .ekit-double-btn.ekit-double-btn-two,.ekit-double-btn-one{
      /* width: 100% !important;
      font-size: .8em !important; */
      i{
        font-size: 12px !important;
      }
    }
}

</style>

<!-- eslint-enable -->
